// extracted by mini-css-extract-plugin
export var messageSideLeft = "_om-1";
export var messageSideRight = "_om-2";
export var orderLookupBubbleContainer = "_om-0";
export var submitButton = "_om-3";